export const sliceWalletAddress = (address: string) => {
  const stars = "****";
  const addressSlice = address.slice(0, 6);
  return addressSlice.concat("", stars);
};
